import { render, staticRenderFns } from "./contactForm.component.vue?vue&type=template&id=f68f974c&scoped=true&"
import script from "./contactForm.component.vue?vue&type=script&lang=js&"
export * from "./contactForm.component.vue?vue&type=script&lang=js&"
import style0 from "./contactForm.component.vue?vue&type=style&index=0&id=f68f974c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68f974c",
  null
  
)

export default component.exports